import { takeEvery, call, put } from 'redux-saga/effects';
import {
  sendRequest,
  updateData,
  requestInProcess,
  requestFinished
} from '../../../../../../common/reducers/data/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import MessengerService from '../../../../services/MessengerService';

function* getMeStatSaga(reducerName) {
  let status = null;
  yield put(requestInProcess(reducerName));
  try {
    const result = yield call(timeoutCall, MessengerService.getMeStat);
    if (result.response) {
      if (result.response.status === 200) {
        yield put(updateData(reducerName, result.destructData));
      }
    }
    status = result.response.status;
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [takeEvery(sendRequest(reducerName).type, getMeStatSaga, reducerName)];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/static/objects/sagas/getMeStatSaga.js